
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.5 5.82l-6 2m6-2v7.332m0-7.333l-6-2m-6 6v7.333m0-7.333l6-2m-6 2l-6-2m-6-2v7.333m0-7.333l6 2m-6-2l6-2m6 20.667v-7.334m0 7.334l6-2m-6 2l-6-2m6-5.334l12-4m-12 4l-12-4m18-5.333v14.667m0-14.667l-12-4m12 18.667l6-2v-7.334m-24 0v7.334l6 2m0-14.667v14.667m0-14.667l12-4m0 0l-6-2-6 2","stroke":"#56BFC7","stroke-width":"2","stroke-linejoin":"round"}})])
          )
        }
      }
    